import axios, { AxiosRequestConfig } from 'axios';

export const _axiosSwr = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
});

export async function axiosSwr<T>(url: string, config?: AxiosRequestConfig) {
  const response = await _axiosSwr(url, config);

  return response.data as T;
}
